module.exports = __webpack_public_path__ + "media/images/flags/BV-657437bf27fdc7d63167337ecf443f93.svg";